import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { Translation, useNavigate } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { Country } from '@swf/core/enums';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { type Dispatch, select } from '@swf/core/store';

import Prompt from '../../Prompt/Prompt';
import ESRegulatoryErrorPrompts from '../ESRegulatoryErrors/ESRegulatoryErrors';

import {
  TXTACL_Your_account_privileges_have_b_ELL,
  TXTCLI_For_more_informationX_please_v_ELL_1,
  TXTCLI_We_apologize_for_the_inconveni_ELL,
  TXTCLI_You_can_contact_Xa_hrefXXN0XXA_ELL,
  TXTMOB_Your_account_has_been_restrict_ELL,
  TXTWCL_Okay,
  TXTWCL_There_has_been_an_issue_with_y_ELL,
  TXTWCL_You_can_still_request_a_withdr_ELL
} from './PlayerBlacklisted.messages.json';
import styles from './PlayerBlacklisted.scss';

interface Props {
  onClose(): void;
  code?: string;
}

const PlayerBlacklisted: React.FC<Props> = ({ onClose, code }) => {
  const { auth } = useDispatch<Dispatch>();
  const isEs = useSelector(select.cms.getSiteId) === Sites.SPA;
  const {
    values: { country, citizenship }
  } = useWizardContext();
  const navigate = useNavigate();
  const { redirectTo } = useSelector(select.localSettings.get);

  const handleClose = () => {
    !isEs && auth.logout();
    redirectTo ? navigate(redirectTo) : navigate('/');
    onClose();
  };

  if (isEs && country !== Country.Spain && citizenship !== Country.Spain) {
    return <ESRegulatoryErrorPrompts code={code as string} onClose={onClose} />;
  }

  return (
    <Prompt
      onClose={handleClose}
      variant="default"
      title={{ translation: TXTWCL_There_has_been_an_issue_with_y_ELL }}
      onPrimaryButtonClick={handleClose}
      primaryButton={{
        translation: TXTWCL_Okay
      }}
    >
      {isEs ? (
        <>
          <p>
            <Translation {...TXTACL_Your_account_privileges_have_b_ELL} />{' '}
            <Translation {...TXTCLI_We_apologize_for_the_inconveni_ELL} />
          </p>
          <Translation tagName="p" {...TXTWCL_You_can_still_request_a_withdr_ELL} />
        </>
      ) : (
        <>
          <p className={styles.text}>
            <Translation {...TXTMOB_Your_account_has_been_restrict_ELL} />
          </p>
          <div className={styles.text}>
            <Translation
              tagName="p"
              {...TXTCLI_You_can_contact_Xa_hrefXXN0XXA_ELL}
              values={{
                a: (msg: React.ReactNode) => (
                  <ResolverLink resolverTag={ResolverTag.ANJRGExclude}>{msg}</ResolverLink>
                )
              }}
            />
          </div>
          <Translation
            tagName="p"
            {...TXTCLI_For_more_informationX_please_v_ELL_1}
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />
        </>
      )}
    </Prompt>
  );
};

export default PlayerBlacklisted;
